module.exports = __webpack_public_path__ + "img/code.d03b2117.png";